<template>
  <div>
    <template v-if="shouldShowNavbar">
      <MainNavbar />
    </template>
    <div style="background-color: #F9F9F9;margin-top: 70px;">
      <RouterView></RouterView>
    </div>
  </div>
</template>

<script>
import MainNavbar from "@/components/Navbar.vue";
// import { RouterView } from "vue-router";
import { initFlowbite } from 'flowbite'

export default {
  name: 'App',
  components: {
    MainNavbar,
    // RouterView,

  },
  // watch: {
  //   '$route'(to) {
  //     this.shouldShowNavbar = !to.name || to.name !== 'Login';
  //   },
  // },
  mounted() {
    initFlowbite();

  },
  computed: {
    shouldShowNavbar() {
      // Logic to determine if the navbar should be shown
      return this.$route.name !== 'Login';
    },
  },

}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

::webkit-scrollbar {
  width: 12px;
}

::webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::webkit-scrollbar-thumb {
  background-color: #888;
}

::webkit-scrollbar-thumb:hover {
  background-color: #555;
}

body {
  background-color: #fff;
  overflow-x: hidden;
  font-family: sans-serif;
}
</style>